import { useEffect, useState } from 'react';
import { Dialog, DialogIberiaContent } from '../../../../../navigation/dialog/Dialog';
import styles from './PassengerDataCheckModal.module.css';
import { useTranslation } from 'react-i18next';

export type PassengerDataCheckModalProps = {
	open: boolean;
	onClose: () => void;
	onPrimaryAction: () => void;
	defaultOutsider?: boolean;
	isHidden?: boolean;
};

const handleUserInteraction =
	(setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>, onClose: () => void, onPrimaryAction: () => void) =>
	(type: string) => {
		if (type === 'CANCEL') {
			setOpenDialog(false);
			onClose();
		}
		if (type === 'PRIMARY') {
			onPrimaryAction();
		}
	};

export const PassengerDataCheckModal = ({
	open,
	onClose,
	onPrimaryAction,
	defaultOutsider = false,
	isHidden = false
}: PassengerDataCheckModalProps) => {
	const { t } = useTranslation(['passenger-data-check-modal', 'common']);
	const [openDialog, setOpenDialog] = useState(open);

	useEffect(() => {
		setOpenDialog(open);
	}, [open]);

	const handleDialogClose = (isOpen: boolean) => {
		if (!isOpen) {
			onClose();
		}
	};

	return (
		<Dialog open={openDialog} onOpenChange={handleDialogClose}>
			<DialogIberiaContent
				header={t('TITLE')}
				body={t('MESSAGE_BODY')}
				primaryButton={t('common:CONTINUE')}
				cancelButton={t('RETURN_AND_COMPLETE')}
				onUserInteraction={handleUserInteraction(setOpenDialog, onClose, onPrimaryAction)}
				className={styles.modalContent}
				defaultOutsider={defaultOutsider}
				isHidden={isHidden}
			/>
		</Dialog>
	);
};
